/*
 * Tailroute: make shoppers choose a size on the product page.
 *
 * Meta ad links open a product with ?variant=…, which pre-selects
 * one size – often the largest. Until the shopper picks a size themselves we:
 *   - clear the selected size,
 *   - disable Add to cart and hide the express checkout buttons,
 *   - show "Choose a size to add to cart".
 * Colour stays as linked. Applies to the main product form only (not quick add or product cards).
 */
(() => {
  if (window.trRequireSize) return;
  window.trRequireSize = true;

  // Meta ad/catalog traffic only. Google Shopping requires the landing page to keep the linked
  // variant pre-selected with a working Add to cart, so Google, organic and crawler visits are untouched.
  const params = new URLSearchParams(location.search);
  const source = (params.get('utm_source') || '').toLowerCase();
  const fromMeta = params.has('fbclid') || ['facebook', 'instagram', 'fb', 'ig', 'meta'].includes(source);
  const fromGoogle = params.has('gclid') || params.has('gbraid') || params.has('wbraid') || params.has('srsltid') || source === 'google';
  const isBot = navigator.webdriver || /bot|crawl|spider|google|storebot|facebookexternalhit/i.test(navigator.userAgent);
  if (!fromMeta || fromGoogle || isBot) return;

  const chosen = new Set(); // product ids where the shopper picked a size
  const NOTE_CLASS = 'tr-size-required';

  const isMainPicker = (fs) =>
    !fs.closest('quick-add-dialog, product-card, .quick-add, featured-product-information') &&
    fs.closest('variant-picker')?.dataset.templateProductMatch === 'true';

  const scopeOf = (fs) => fs.closest('.product-details, product-details') || fs.closest('main') || document;

  function lock(fs) {
    const scope = scopeOf(fs);
    scope.classList.add('tr-size-locked');

    fs.querySelectorAll('input[type="radio"]').forEach((input) => {
      if (input.checked) input.checked = false;
      input.dataset.currentChecked = 'false';
    });

    const value = fs.querySelector('.variant-option__swatch-value');
    if (value && value.textContent !== '') value.textContent = '';

    scope.querySelectorAll('button[name="add"]').forEach((btn) => {
      if (!btn.dataset.trSizeLock) btn.dataset.trSizeLock = btn.disabled ? 'was-disabled' : 'on';
      btn.disabled = true;
    });

    if (!fs.parentElement?.querySelector(`.${NOTE_CLASS}`)) {
      const note = document.createElement('p');
      note.className = NOTE_CLASS;
      note.setAttribute('role', 'status');
      note.textContent = 'Choose a size to add to cart';
      fs.insertAdjacentElement('afterend', note);
    }
  }

  function unlock(fs) {
    const scope = scopeOf(fs);
    scope.classList.remove('tr-size-locked');
    scope.querySelectorAll('button[name="add"][data-tr-size-lock]').forEach((btn) => {
      if (btn.dataset.trSizeLock === 'on') btn.disabled = false;
      delete btn.dataset.trSizeLock;
    });
    fs.parentElement?.querySelectorAll(`.${NOTE_CLASS}`).forEach((n) => n.remove());
  }

  function apply() {
    document.querySelectorAll('fieldset[data-tr-require-size]').forEach((fs) => {
      if (!isMainPicker(fs)) return;
      const id = fs.dataset.trRequireSize;
      if (chosen.has(id)) {
        if (scopeOf(fs).classList.contains('tr-size-locked')) unlock(fs);
        return;
      }
      lock(fs);
    });
  }

  // Shopper picks a size: stop interfering for this product.
  document.addEventListener(
    'change',
    (event) => {
      const fs = event.target instanceof Element && event.target.closest('fieldset[data-tr-require-size]');
      if (!fs || !isMainPicker(fs)) return;
      chosen.add(fs.dataset.trRequireSize);
      unlock(fs);
    },
    true
  );

  // Re-apply after the theme re-renders the product section (e.g. colour change).
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  });

  const start = () => {
    apply();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
